import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Messages from './Messages/Messages';
import FindLicensee from './Licensees/Licensees';
import Forms from './Forms/Forms';
import { default as withWidth, isWidthUp } from '@material-ui/core/withWidth';
import FeeTypes from './FeeTypes/FeeTypes';
import LicenseTypes from './LicensesTypes/LicenseTypes';
import Workflows from './Workflow/Workflow';

const styles = (theme) => ({
    content: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
    },
    actionBar: {
        textAlign: 'center',
    },
});

class Dashboard extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.onLoad();
    }

    render() {
        const spacing = isWidthUp('sm', this.props.width) ? 2 : 0;

        return (
            <Grid container>
                {this.props.activeNavItem === 'forms' && <Forms spacing={spacing} />}
                {this.props.activeNavItem === 'messages' && <Messages />}
                {this.props.activeNavItem === 'licenseTypes' && <LicenseTypes />}
                {this.props.activeNavItem === 'licensees' && <FindLicensee />}
                {this.props.activeNavItem === 'feeTypes' && <FeeTypes />}
                {this.props.activeNavItem === 'workflows' && <Workflows />}
            </Grid>
        );
    }
}

export default withRouter(withWidth()(withStyles(styles)(Dashboard)));
